import React from 'react';

import { getFundsApplicationButtonState } from '../../../../../../../../store/product/constants';
import { ProductButtonProps } from '../../../../../../../BatchTicket/components/DynamicButton';
import { ApplicationButton } from '../../components/ApplicationButton';

export const FundsButton: React.FC<ProductButtonProps<'funds'>> = (props) => {
  const buttonProps = getFundsApplicationButtonState(props.offer);

  if (props.offer.isReaplicationNormalized) {
    return (
      <ApplicationButton
        {...props}
        buttonVariant="primary"
        buttonText="Reaplicar"
        mobileButtonIconColor="brand.tertiary.principal"
        idSelector="productIdNormalized"
        isDisabled={buttonProps.isDisabled}
        tooltip={buttonProps.tooltip}
      />
    );
  }

  return (
    <ApplicationButton
      {...props}
      idSelector="productIdNormalized"
      isDisabled={buttonProps.isDisabled}
      tooltip={buttonProps.tooltip}
    />
  );
};
